const modalPostulacionExitosa = {
  'Otros avisos que pueden interesarte': 'Otros avisos que pueden interesarte',
  'Te postulaste con éxito': 'Te postulaste con éxito',
  '¡Mucha suerte en el proceso de selección!': '¡Mucha suerte en el proceso de selección!',
  '¡Listo!': '¡Listo!',
}

export default modalPostulacionExitosa
